// frontend/src/components/themed/ThemedCard.js - Professional themed card component
import { useTheme } from '../../contexts/ThemeContext';

const ThemedCard = ({ 
  children, 
  className = '',
  onClick,
  hoverable = false,
  selected = false,
  padding = 'md',
  shadow = 'sm',
  ...props 
}) => {
  const { components, shadow: shadows, cn } = useTheme();

  // Padding sizes
  const paddingSizes = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  // Build classes
  const cardClasses = cn(
    components.card.base,
    paddingSizes[padding],
    shadows[shadow] || shadows.sm,
    hoverable ? components.card.hover : '',
    selected ? components.card.selected : '',
    onClick ? 'cursor-pointer' : '',
    className
  );

  return (
    <div 
      className={cardClasses} 
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

// Card Header subcomponent
const CardHeader = ({ children, className = '', divider = true }) => {
  const { text, border, cn } = useTheme();
  
  const headerClasses = cn(
    'pb-4',
    divider ? `border-b ${border.default}` : '',
    className
  );

  return (
    <div className={headerClasses}>
      <h3 className={`text-lg font-semibold ${text.primary}`}>
        {children}
      </h3>
    </div>
  );
};

// Card Body subcomponent
const CardBody = ({ children, className = '' }) => {
  const { cn } = useTheme();
  
  return (
    <div className={cn('py-4', className)}>
      {children}
    </div>
  );
};

// Card Footer subcomponent
const CardFooter = ({ children, className = '', divider = true }) => {
  const { border, cn } = useTheme();
  
  const footerClasses = cn(
    'pt-4',
    divider ? `border-t ${border.default}` : '',
    className
  );

  return (
    <div className={footerClasses}>
      {children}
    </div>
  );
};

// Attach subcomponents to main component
ThemedCard.Header = CardHeader;
ThemedCard.Body = CardBody;
ThemedCard.Footer = CardFooter;

export default ThemedCard;